export default __webpack_public_path__ + "static/media/hud1.36d04572.gif";